// src/app/slices/silencerSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SilencerState, ISilencer, ISilencerParams } from '../models';

const initialState: SilencerState = {
  silencers: {},
  silencer_params: null,
};

const silencerSlice = createSlice({
  name: 'silencer',
  initialState,
  reducers: {
    setSilencer: (state, action: PayloadAction<ISilencer>) => {
      state.silencers[action.payload.id] = action.payload;
    },
    setSilencerParams: (state, action: PayloadAction<ISilencerParams>) => {
      state.silencer_params = action.payload;
    },
  },
});

export const { setSilencer, setSilencerParams } = silencerSlice.actions;

export default silencerSlice.reducer;
